var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoBjWin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    overflow: "visible",
    viewBox: "0 0 19 19",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.938,
    cy: 9,
    r: 9,
    fill: "#398076"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m15.473 4.5-2.256 8.568h-1.38l-1.512-5.292a9 9 0 0 1-.144-.48l-.12-.516-.108-.468A8 8 0 0 0 9.893 6a5 5 0 0 1-.048.312 10 10 0 0 1-.096.468q-.06.252-.12.528-.06.264-.132.504L8.01 13.068H6.63L4.385 4.5h1.332l1.26 5.064.12.54q.06.276.108.552.06.276.096.54.048.252.084.468.036-.228.072-.492.048-.264.108-.54l.12-.564q.072-.276.144-.504L9.257 4.5h1.296l1.476 5.088q.072.24.132.516.072.276.132.564.06.276.096.54.048.252.084.456.036-.3.096-.648.072-.36.156-.732.084-.384.168-.72l1.26-5.064z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoBjWin);
export default __webpack_public_path__ + "static/media/IcoBJWin.6d126c41ccf8be48d745a239c400ecf5.svg";
export { ForwardRef as ReactComponent };